var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70711 2.27727C8.31658 1.88674 7.68342 1.88674 7.29289 2.27727L4.29289 5.27727C3.90237 5.66779 3.90237 6.30096 4.29289 6.69148C4.68342 7.08201 5.31658 7.08201 5.70711 6.69148L8 4.39859L10.2929 6.69148C10.6834 7.08201 11.3166 7.08201 11.7071 6.69148C12.0976 6.30096 12.0976 5.66779 11.7071 5.27727L8.70711 2.27727ZM4.29289 10.6759L7.29289 13.6759C7.68342 14.0664 8.31658 14.0664 8.70711 13.6759L11.7071 10.6759C12.0976 10.2853 12.0976 9.65217 11.7071 9.26165C11.3166 8.87112 10.6834 8.87112 10.2929 9.26165L8 11.5545L5.70711 9.26165C5.31658 8.87112 4.68342 8.87112 4.29289 9.26165C3.90237 9.65217 3.90237 10.2853 4.29289 10.6759Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.73780de02e50f929b036289b6f876307.svg";
export { ForwardRef as ReactComponent };